import { Directive, HostBinding, Input, OnInit } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

@Directive({
  selector: '[uiSvg]'
})
export class SvgDirective implements OnInit {
  @HostBinding('innerHTML') svg: SafeHtml;
  @Input() source: string;

  constructor(
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.httpClient
    .get(`${this.source}.svg`, { responseType: 'text' })
    .subscribe(
      res =>  {
        this.svg = this.sanitizer.bypassSecurityTrustHtml(res);
      });
    }
}
